module.exports = __webpack_public_path__ + "img/icon16.b988cbfe.png";